<div class="td-wb-w8ben-form-success-message">
  <div class="td-wb-w8ben-form-success-message__title"
       translate="tdWb.w8BenForm.modal.successMessage.TITLE">
  </div>
  <td-wb-icon class="td-wb-w8ben-form-success-message__icon"
              iconId="circle-success"
              size="60"
              iconType="primary" />
  <div class="td-wb-w8ben-form-success-message__content">
    <ng-content />
  </div>
  <button id="td-wb-w8ben-form-success-message-done"
          class="td-wb-w8ben-form-success-message__button"
          tdWbButton
          tdWbButtonType="primary"
          [tdWbModalClose]="closeReason">
    <span translate="tdWb.w8BenForm.modal.successMessage.DONE"></span>
  </button>
</div>
